import React, { useState, useEffect } from "react";
import axios from "axios";
import { Input, Button, Modal, ModalHeader, ModalBody } from "reactstrap";

const VendorDocumentRow = ({ vendorId, files, isEditing }) => {
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [panFile, setPanFile] = useState(null);
    const [gstFile, setGstFile] = useState(null);
    const [msmeFile, setMsmeFile] = useState(null);
    const [chequeFile, setChequeFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [showPreview, setShowPreview] = useState(false);
    const [previewTitle, setPreviewTitle] = useState("Document Preview");
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => {
        if (vendorId) {
            axios
                .get(`/api/vendor/files/vendor/${vendorId}`)
                .then((res) => setUploadedFiles(res.data))
                .catch((err) => console.error("Failed to fetch uploaded files:", err));
        }
    }, [vendorId]);

    const uploadFile = async (file, docName) => {
        if (!file) return;

        const formData = new FormData();
        formData.append("VendorID", vendorId);
        formData.append("DocName", docName);
        formData.append("File", file);

        try {
            await axios.post("/api/vendor/files/upload", formData);
            const res = await axios.get(`/api/vendor/files/vendor/${vendorId}`);
            setUploadedFiles(res.data);
            alert(`${docName} uploaded successfully.`);
        } catch (err) {
            console.error("File upload failed:", err);
            alert("File upload failed.");
        }
    };

    const getFileLink = (docName) => {
        const file = uploadedFiles.find(
            (f) => f.docName?.trim().toLowerCase() === docName.trim().toLowerCase()
        );
        if (!file) return <span style={{ color: "gray" }}>No file</span>;

        const fileUrl = `/api/vendor/files/${file.fileId}?mode=view`;
        const titleMap = {
            PAN: "PAN Card Preview",
            GST: "GST Certificate Preview",
            MSME: "MSME Certificate Preview",
            Cheque: "Cancelled Cheque Preview",
        };
        const displayFileName =
            file.fileName.length > 18 ? `${file.fileName.slice(0, 18)}…` : file.fileName;

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    maxWidth: "100%",
                    overflow: "hidden",
                }}
            >
                {/* File name (truncated, never overflows the cell) */}
                <span
                    title={file.fileName}
                    style={{
                        color: "#0a4275",
                        fontWeight: "500",
                        marginBottom: "6px",
                        maxWidth: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}
                >
                    {displayFileName}
                </span>

                {/* View & Download buttons below — wrap instead of overflowing */}
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", maxWidth: "100%" }}>
                    <Button
                        color="primary"
                        size="sm"
                        outline
                        onClick={() => {
                            setPreviewUrl(fileUrl);
                            setPreviewTitle(titleMap[docName] || "Document Preview");
                            setSelectedFile(file);
                            setShowPreview(true);
                        }}
                    >
                        View
                    </Button>
                    
                </div>
            </div>
        );
    };

    return (
        <>
            {/* Preview Modal */}
            <Modal isOpen={showPreview} toggle={() => setShowPreview(false)} size="lg">
                <ModalHeader toggle={() => setShowPreview(false)}>{previewTitle}</ModalHeader>
                <ModalBody style={{ textAlign: "center", padding: "0" }}>
                    {selectedFile ? (
                        selectedFile.fileName?.toLowerCase().endsWith(".pdf") ? (
                            <iframe
                                src={previewUrl}
                                title={previewTitle}
                                style={{
                                    width: "100%",
                                    height: "80vh",
                                    border: "none",
                                    display: "block",
                                }}
                            />
                        ) : (
                            <img
                                src={previewUrl}
                                alt={selectedFile.fileName}
                                style={{
                                    maxWidth: "100%",
                                    maxHeight: "80vh",
                                    display: "block",
                                    margin: "0 auto",
                                }}
                            />
                        )
                    ) : (
                        <p>No preview available.</p>
                    )}
                </ModalBody>
            </Modal>

            {/* Document Upload Section */}
            <tr>
                <td>PAN Card</td>
                <td>
                    {isEditing ? (
                        <>
                            <Input
                                type="file"
                                onChange={(e) => setPanFile(e.target.files[0])}
                                className="mt-1"
                            />
                            <Button
                                color="primary"
                                size="sm"
                                className="mt-1"
                                onClick={() => uploadFile(panFile, "PAN")}
                            >
                                Upload PAN
                            </Button>
                        </>
                    ) : (
                        <>{getFileLink("PAN")}</>
                    )}
                </td>

                <td>GST Certificate</td>
                <td>
                    {isEditing ? (
                        <>
                            <Input
                                type="file"
                                onChange={(e) => setGstFile(e.target.files[0])}
                                className="mt-1"
                            />
                            <Button
                                color="primary"
                                size="sm"
                                className="mt-1"
                                onClick={() => uploadFile(gstFile, "GST")}
                            >
                                Upload GST
                            </Button>
                        </>
                    ) : (
                        <>{getFileLink("GST")}</>
                    )}
                </td>
            </tr>

            <tr>
                <td>MSME Certificate</td>
                <td>
                    {isEditing ? (
                        <>
                            <Input
                                type="file"
                                onChange={(e) => setMsmeFile(e.target.files[0])}
                                className="mt-1"
                            />
                            <Button
                                color="primary"
                                size="sm"
                                className="mt-1"
                                onClick={() => uploadFile(msmeFile, "MSME")}
                            >
                                Upload MSME
                            </Button>
                        </>
                    ) : (
                        <>{getFileLink("MSME")}</>
                    )}
                </td>

                <td>Cancelled Cheque</td>
                <td>
                    {isEditing ? (
                        <>
                            <Input
                                type="file"
                                onChange={(e) => setChequeFile(e.target.files[0])}
                                className="mt-1"
                            />
                            <Button
                                color="primary"
                                size="sm"
                                className="mt-1"
                                onClick={() => uploadFile(chequeFile, "Cheque")}
                            >
                                Upload Cheque
                            </Button>
                        </>
                    ) : (
                        <>{getFileLink("Cheque")}</>
                    )}
                </td>
            </tr>
        </>
    );
};

export default VendorDocumentRow;
